// Dependencies.
import styled from 'styled-components'

// Img.
const Img = styled.img`
  margin: auto 12px;
  width: 14px;
`

// Dropdown Indicator.
export const DropdownIndicator: React.FC = (props) => (
  <Img src="/images/downArrow.png" />
)
